import * as Constants from "../constants";

export const createUserLiveSession = () => ({
  type: Constants.CREATE_USER_LIVE_SESSION,
});

export const createUserLiveSessionSuccess = (data) => ({
  type: Constants.CREATE_USER_LIVE_SESSION_SUCCESS,
  payload: data,
});

export const createUserLiveSessionError = (error) => ({
  type: Constants.CREATE_USER_LIVE_SESSION_ERROR,
  error,
});

export const finishUserLiveSession = () => ({
  type: Constants.FINISH_USER_LIVE_SESSION,
});

export const finishUserLiveSessionSuccess = (data) => ({
  type: Constants.FINISH_USER_LIVE_SESSION_SUCCESS,
  payload: data,
});

export const finishUserLiveSessionError = (error) => ({
  type: Constants.FINISH_USER_LIVE_SESSION_ERROR,
  error,
});
